export const RADIO_OPTIONS = [
  {
    id: '38',
    label: 'Canjear premio',
  },
  {
    id: '39',
    label: 'Ver estado de solicitud de canje',
  },
  {
    id: '40',
    label: 'Ingresar una boleta',
  },
  {
    id: '41',
    label: 'Cambiar fecha de matrimonio',
  },
  {
    id: '42',
    label: 'Recuperar contraseña',
  },
];

export const PREFORM_FIELDS = [
  {
    name: 'codeClubes',
    inputAdornment: '',
    label: 'Código de clubes',
    disabled: false,
    required: true,
    helper: 'Ingresa 9 dígitos',
  },
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
];
